import { forbiddenFileNameCharsPattern } from '@shs-digi-care-monorepo/interfaces';

export interface FileNameValidationError {
    fileName: string;
    reason: string;
    params?: Record<string, unknown>;
}

export const FRONTEND_FILE_NAME_MAX_LENGTH = 54;

export class FileNameValidationOperations {
    public static validateFileName(
        fileName: string,
        maxLength: number = FRONTEND_FILE_NAME_MAX_LENGTH
    ): FileNameValidationError | null {
        if (fileName.length === 0) {
            return { fileName, reason: 'common.file-upload.empty-name' };
        }

        let decodedName: string;
        try {
            decodedName = decodeURIComponent(fileName);
        } catch {
            return { fileName, reason: 'common.file-upload.invalid-encoding' };
        }

        if (forbiddenFileNameCharsPattern.test(decodedName)) {
            return { fileName, reason: 'common.file-upload.forbidden-characters' };
        }

        if (decodedName.length > maxLength) {
            return {
                fileName,
                reason: 'common.file-upload.file-character-limit',
                params: { maxLength }
            };
        }

        return null;
    }

    public static validateFiles(
        files: File[],
        maxLength: number = FRONTEND_FILE_NAME_MAX_LENGTH
    ): { valid: File[]; errors: FileNameValidationError[] } {
        const valid: File[] = [];
        const errors: FileNameValidationError[] = [];

        for (const file of files) {
            const error = FileNameValidationOperations.validateFileName(file.name, maxLength);
            if (error) {
                errors.push(error);
            } else {
                valid.push(file);
            }
        }

        return { valid, errors };
    }
}
